(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-experience"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('jb-experience-slider')){
 class JBExperienceSlider extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();
   const options={signal:this.controller.signal};
   this.track=this.querySelector('.jbexp__track');
   this.cards=[...this.querySelectorAll('.jbexp__card')];
   this.live=this.querySelector('[data-live]');
   if(!this.track||!this.cards.length)return;
   this.positions=()=>{
    const first=this.cards[0].getBoundingClientRect().left;
    const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
    return this.cards.map(card=>Math.min(max,card.getBoundingClientRect().left-first));
   };
   this.index=()=>{
    const points=this.positions();
    return points.reduce((best,p,i)=>Math.abs(p-this.track.scrollLeft)<Math.abs(points[best]-this.track.scrollLeft)?i:best,0);
   };
   this.go=index=>{
    const target=Math.max(0,Math.min(this.cards.length-1,index));
    this.track.scrollTo({left:this.positions()[target],behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    this.live.textContent=this.cards[target].querySelector('.jbexp__title').textContent;
   };
   this.track.addEventListener('keydown',event=>{
    if(this.track.scrollWidth<=this.track.clientWidth+2)return;
    const keys={ArrowRight:this.index()+1,ArrowLeft:this.index()-1,Home:0,End:this.cards.length-1};
    if(Object.hasOwn(keys,event.key)){event.preventDefault();this.go(keys[event.key]);}
   },options);
   this.track.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0||this.track.scrollWidth<=this.track.clientWidth+2)return;
    this.drag={x:event.clientX,left:this.track.scrollLeft};
    this.track.setPointerCapture(event.pointerId);
    this.track.classList.add('is-dragging');
   },options);
   this.track.addEventListener('pointermove',event=>{
    if(this.drag)this.track.scrollLeft=this.drag.left+this.drag.x-event.clientX;
   },options);
   const stop=()=>{
    if(!this.drag)return;
    this.drag=null;
    this.track.classList.remove('is-dragging');
    this.go(this.index());
   };
   this.track.addEventListener('pointerup',stop,options);
   this.track.addEventListener('pointercancel',stop,options);
   this.track.addEventListener('lostpointercapture',stop,options);
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.drag=null;}
 }
 customElements.define('jb-experience-slider',JBExperienceSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-maison-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jb-creation-carousel')) {
  customElements.define('jb-creation-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.jb-editorial__categories-track');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      const update = () => {
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (!button || !this.contains(button)) return;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({left: Number(button.dataset.direction) * this.track.clientWidth, behavior: reduced ? 'instant' : 'smooth'});
      }, {signal});
      this.track.addEventListener('scroll', update, {passive: true, signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-reference-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jb-reference-footer')) {
  customElements.define('jb-reference-footer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      const button=this.querySelector('[data-footer-sitemap]');
      const sitemap=this.querySelector('#JBFooterSitemap');
      if (!button || !sitemap) return;
      button.setAttribute('aria-expanded', String(sitemap.open));
      button.addEventListener('click',()=>{
        const expanded=button.getAttribute('aria-expanded')!=='true';
        const start=sitemap.open?sitemap.getBoundingClientRect().height:0;
        this.animation?.cancel();
        this.fade?.cancel();
        const revision=this.revision=(this.revision||0)+1;
        sitemap.open=true;
        sitemap.inert=!expanded;
        button.setAttribute('aria-expanded',String(expanded));
        const finish=()=>{if(this.revision===revision){sitemap.open=expanded;sitemap.inert=false;sitemap.style.removeProperty('overflow');}};
        if(matchMedia('(prefers-reduced-motion:reduce)').matches){finish();return;}
        sitemap.style.overflow='hidden';
        const end=expanded?sitemap.getBoundingClientRect().height:0;
        if(expanded) this.fade=sitemap.querySelector('.jb-footer-sitemap')?.animate({opacity:[0,1]},{duration:2000,easing:'ease'});
        this.animation=sitemap.animate({height:[`${start}px`,`${end}px`]}, {duration:500,easing:'ease-out'});
        this.animation.finished.then(finish).catch(()=>{});
      },{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();this.animation?.cancel();this.fade?.cancel();const sitemap=this.querySelector('#JBFooterSitemap');if(sitemap){sitemap.inert=false;sitemap.style.removeProperty('overflow');}}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
if (!customElements.get('jb-newsroom-list')) {
  customElements.define('jb-newsroom-list', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.entries = this.querySelector('[data-newsroom-entries]');
      this.more = this.querySelector('[data-newsroom-more]');
      this.status = this.querySelector('[data-newsroom-status]');
      this.error = this.querySelector('[data-newsroom-error]');
      this.loading = false;
      if (!this.more || !this.entries) return;
      this.label = this.more.textContent;
      this.more.addEventListener('click', event => this.loadNext(event), {signal: this.controller.signal});
    }
    async loadNext(event) {
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.loading || this.more.hidden) return;
      this.loading = true;
      this.error.hidden = true;
      this.more.setAttribute('aria-disabled', 'true');
      this.more.setAttribute('aria-busy', 'true');
      this.more.textContent = this.dataset.loadingMessage;
      const lifecycle = this.controller;
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 15000);
      try {
        const current = new URL(window.location.href);
        const url = new URL(this.more.getAttribute('href'), current);
        if (url.origin !== current.origin || url.pathname !== current.pathname) throw new Error('Invalid page');
        current.searchParams.forEach((value, key) => {
          if (key !== 'page' && key !== 'section_id' && !url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, {credentials: 'same-origin', signal: request.signal});
        if (!response.ok) throw new Error('Page unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (lifecycle.signal.aborted || !this.isConnected) return;
        const next = document.querySelector('jb-newsroom-list');
        if (!next || next.dataset.sectionId !== this.dataset.sectionId || Number(next.dataset.page) !== Number(this.dataset.page) + 1) throw new Error('Unexpected page');
        const known = new Set([...this.entries.querySelectorAll('[data-article-id]')].map(entry => entry.dataset.articleId));
        const additions = [...next.querySelectorAll('[data-newsroom-entry]')].filter(entry => {
          const id = entry.dataset.articleId;
          if (!id || known.has(id)) return false;
          known.add(id);
          return true;
        });
        if (!additions.length) throw new Error('No new articles');
        this.entries.append(...additions);
        this.dataset.page = next.dataset.page;
        const following = next.querySelector('[data-newsroom-more]');
        if (following) this.more.setAttribute('href', following.getAttribute('href'));
        else this.more.hidden = true;
        this.status.textContent = this.dataset.loadedMessage
          .replace('[count]', String(additions.length))
          .replace('[total]', String(this.entries.querySelectorAll('[data-newsroom-entry]').length));
        if (event.detail === 0) additions[0].querySelector('a')?.focus();
      } catch (error) {
        if (!lifecycle.signal.aborted && this.isConnected) {
          this.status.textContent = '';
          this.error.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        if (this.controller === lifecycle && this.isConnected) {
          this.loading = false;
          this.more.textContent = this.label;
          this.more.removeAttribute('aria-disabled');
          this.more.removeAttribute('aria-busy');
          this.request = null;
        }
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
